import { RdPathLoader, ExportTaxLayout } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

export const ExportTax = (): React.ReactElement => (
  <RdPathLoader path={Path.EXPORT_TAX} useRedirect={() => ({ isLoading: false })}>
    <ExportTaxLayout />
  </RdPathLoader>
);
